import { memo } from "react";

export const CustomerEmailSubscriberDetails = memo(
  function CustomerEmailSubscriberDetails() {
    return null;
  },
);
